var map = {
	"./blank/Settings.vue": "d99f",
	"./carousel/Settings.vue": "ab04",
	"./embed/Settings.vue": "842b",
	"./g2-heatmap/Settings.vue": "4184",
	"./g2-mix/Settings.vue": "0d49",
	"./g2-progress-bullet/Settings.vue": "4e35",
	"./g2-progress-ring/Settings.vue": "1f18",
	"./g2-progress-stick/Settings.vue": "4a9c",
	"./g2-progress-wave/Settings.vue": "d423",
	"./g2-relation/Settings.vue": "a88b",
	"./params/Settings.vue": "a1a3",
	"./scroll/Settings.vue": "4eae",
	"./table/Settings.vue": "dede"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6522";